import { observer } from "mobx-react";
import React from "react";

type Props = {
	imageUrl: string;
};

type State = {};

@observer
class ModuleImageRendering extends React.Component<Props, State> {
	render() {
		return <img src={this.props.imageUrl} className="module-image" alt="module"></img>;
	}
}

export default ModuleImageRendering;
